import { useQuery } from '@tanstack/react-query';
import { RECHERCHE_MIN, type Recherche } from '@sirajoptic/shared';
import { api } from '@/lib/api-client';

export const clesRecherche = {
  tous: ['recherche'] as const,
  terme: (q: string) => ['recherche', q] as const,
};

/**
 * Recherche globale. La requête ne part qu'à partir de deux caractères, et le
 * résultat est gardé une minute : on retape souvent le même nom dans la même
 * demi-heure, et la palette doit répondre instantanément la deuxième fois.
 */
export function useRechercheGlobale(terme: string) {
  const q = terme.trim();
  return useQuery({
    queryKey: clesRecherche.terme(q),
    queryFn: () => api.get<Recherche>('/recherche', { q }),
    enabled: q.length >= RECHERCHE_MIN,
    staleTime: 60_000,
    placeholderData: (precedent) => precedent,
  });
}
